import { gql } from '@apollo/client';
import { Spinner } from 'components/spinner';
import {
  Events,
  useSearchFestivalsLazyQuery,
  SearchFestivalsQueryResult,
} from 'lib/graphql-generated';
import { Dispatch, SetStateAction } from 'react';
import { MultiSelect, MultiSelectData } from './multi-select';

const SEARCH_FESTIVALS = gql`
  query SearchFestivals($search: String) {
    events(
      where: {
        _and: [{ title: { _ilike: $search } }, { is_festival: { _eq: true } }]
      }
    ) {
      title
      id
      start_time
    }
  }
`;

export type FestivalSelectorValue = MultiSelectData<
  SearchFestivalsQueryResult['data']['events'][0]
>;

export const SerializeFestivals = (
  categories: Partial<Events>[]
): FestivalSelectorValue[] => {
  const arr =
    categories?.map(
      (c): FestivalSelectorValue =>
        c && {
          label: c.title,
          key: c.id,
          data: { title: c.title, id: c.id, start_time: c.start_time },
        }
    ) ?? [];

  return arr.filter((obj) => obj);
};

interface Props {
  label?: string;
  value: FestivalSelectorValue[];
  setValue: Dispatch<SetStateAction<MultiSelectData<Partial<Events>>[]>>;
  className?: string;
}

export function FestivalSelector({ label, value, setValue, className }: Props) {
  const [search, { data, loading, error }] = useSearchFestivalsLazyQuery({
    fetchPolicy: 'no-cache',
  });

  const handleSearch = (value) => {
    if (value.length >= 2) {
      search({ variables: { search: `%${value}%` } });
    }
  };

  return (
    <MultiSelect
      className={className}
      id={label?.replace(' ', '') || 'tagSelector'}
      label={label}
      onSearch={handleSearch}
      placeholder='Search by festival name'
      searchResults={data?.events.map((e) => ({
        label: e.title,
        key: e.id,
        data: e,
      }))}
      values={value}
      setValues={setValue}
      notFoundContent={loading ? <Spinner /> : null}
      singleSelect={true}
    />
  );
}
